import { notification, message } from 'antd'
import * as queryString from 'query-string'
import moment from 'moment'

export function showNoti(type: 'success' | 'error' | 'warning' | 'info', text: string) {
  notification[type]({
    message: 'Thông báo',
    description: text,
  })
}

export function showMessage(type: 'info' | 'success' | 'error' | 'warning' | 'loading', text: string) {
  message[type](text, 4.5)
}

export function isEmailValid(email: string) {
  let re =
    /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
  return re.test(email)
}

export function isPhoneValid(phone: string) {
  try {
    const phoneUtil = require('google-libphonenumber').PhoneNumberUtil.getInstance()
    const phoneNumber = phoneUtil.parse(phone, 'VN')
    return phoneUtil.isValidNumber(phoneNumber, 'VN')
  } catch (e) {
    return false
  }
}

/**
 * Chuẩn SĐT VN để hiển thị + link tel:+84… (thêm 0 nếu thiếu; 84 đầu → 0).
 * Trả về null nếu chuỗi rỗng.
 */
export function formatVnPhoneForDisplayLink(phone?: string | null): { display: string; href: string } | null {
  if (phone == null) return null
  const trimmed = String(phone).trim()
  if (!trimmed) return null

  let digits = trimmed.replace(/\D/g, '')
  if (digits.startsWith('84')) {
    digits = '0' + digits.slice(2)
  }
  // 9 số, không có 0 (mobile VN 3xx…)
  if (digits.length === 9 && /^[3-9]/.test(digits)) {
    digits = '0' + digits
  }

  let href: string
  if (digits.length >= 9 && digits.length <= 11 && /^0/.test(digits)) {
    href = `tel:+84${digits.slice(1)}`
  } else if (digits.length >= 8) {
    href = `tel:+${digits}`
  } else {
    href = `tel:${trimmed.replace(/\s/g, '')}`
  }

  let display = trimmed
  if (digits.length === 10 && digits.startsWith('0')) {
    display = `${digits.slice(0, 4)} ${digits.slice(4, 7)} ${digits.slice(7)}`
  } else if (digits.length === 11 && digits.startsWith('0')) {
    display = `${digits.slice(0, 5)} ${digits.slice(5, 8)} ${digits.slice(8)}`
  } else if (digits.length >= 9) {
    display = digits
  }

  return { display, href }
}

export function handleError(err: any) {
  if (err.message) showMessage('error', err.message + ' (' + err.code + ')')
  else {
    console.error(err)
  }
}

export function getBase64(file: any) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader()
    reader.readAsDataURL(file)
    reader.onload = () => resolve(reader.result)
    reader.onerror = (error) => reject(error)
  })
}

export function showPrice(price: number | undefined) {
  if (price == undefined) return ""
  return Number(price).toLocaleString('en-US', { maximumFractionDigits: 6, useGrouping: true })
}

export function numberExcel(price: number | undefined) {
  if (price == undefined) return ""
  const formattedNumber = Number(price).toLocaleString('en-US', {
    maximumFractionDigits: 6,
    useGrouping: true,
  });
  const result = formattedNumber.replace(/\./g, '@').replace(/,/g, '.').replace(/@/g, ',');
  return result;
}


export function convertGender(gender: number) {
  if (gender === 1) return 'Nam'
  if (gender === 2) return 'Nữ'
  return ''
}

export const handleChangePaging = ({
  history,
  pathname,
  search,
  page,
  pageSize,
}: {
  history: any
  pathname: string
  search: string
  page: number
  pageSize?: number
}) => {
  const parsed: any = queryString.parse(search)
  parsed.page = page
  if (pageSize) parsed.pageSize = pageSize
  const stringified = queryString.stringify(parsed, { skipEmptyString: true })
  history.push(pathname + '?' + stringified)
}


export function formatter(value: number | undefined) {
  return Number(value).toLocaleString('en-US', { maximumFractionDigits: 6, useGrouping: true })
}



export function formatterSoKhoi(value: number | undefined) {
  return Number(value).toLocaleString('en-US', { maximumFractionDigits: 6, useGrouping: true })
}

export const formatterNumber = (val) => {
  if (!val) return 0;
  return `${val}`.replace(/\B(?=(\d{3})+(?!\d))/g, ".").replace(/\.(?=\d{0,2}$)/g, ",");
}


export const openInNewTab = (url: string) => {
  window.open(url, '_blank', 'noopener,noreferrer');
};

export const openInTab = (url: string) => {
  window.open(url, "_self");
};

export const delay = async (value: number) => {
  await new Promise(resolve => setTimeout(resolve, value));
};

// Hàm kiểm tra quyền Clipboard
export async function requestClipboardPermission(): Promise<boolean> {
  try {
    // @ts-ignore
    const permissionStatus = await navigator.permissions.query({ name: 'clipboard-write' });

    if (permissionStatus.state === "granted" || permissionStatus.state === "prompt") {
      console.log("Quyền clipboard đã được cấp hoặc có thể yêu cầu.");
      return true;
    } else {
      console.error("Quyền clipboard bị từ chối.");
      return false;
    }
  } catch (error) {
    console.error("Không thể kiểm tra quyền clipboard:", error);
    return false;
  }
}

// Hàm sao chép văn bản
export async function copyToClipboardWithPermission(text: string): Promise<void> {
  const hasPermission = await requestClipboardPermission();
  if (hasPermission) {
    try {
      await navigator.clipboard.writeText(text);
      console.log("Văn bản đã được sao chép thành công!");
    } catch (error) {
      console.error("Không thể sao chép văn bản:", error);
    }
  } else {
    console.error("Không có quyền truy cập Clipboard.");
  }
}

// Gọi hàm sao chép
export async function handleCopy() {
  await copyToClipboardWithPermission("Nội dung cần sao chép");
}


export const formatDateTime = (date: string | Date) => {
  return date ? moment(date).format('DD/MM/YYYY | HH:mm') : ''
}
export const formatDate = (date: string | Date) => {
  return date ? moment(date).format('DD/MM/YYYY') : ''
}
export const dateTimeNow = () => {
  return moment().format('DDMMYYYY_HHmmss')
}


export const isHaveValue = (value: any) => {
  return value !== undefined && value !== null && value !== '';
}


